import * as React from "react";
import {Display} from "./panels/display/display";
import {XAxis} from "./panels/x-axis/x-axis";
import {DataLabels} from "./panels/data-labels/data-labels";
import {Colors} from "./panels/colors/colors";
import {TileTitle} from "../common/tile-title/tile-title";
import {YAxes} from "./panels/y-axis/y-axes";
import {Legend} from "./panels/legend/legend";
import {OtherOptions} from "../common/other-options/other-options";
import {ReferenceLines} from "../common/reference-lines/reference-lines";

export const VerticalBar = ({tile, form, size, parentTile, colorsTileConfig, referenceLinesPanel, tileAction, isContainerTile}) =>
    [Display, TileTitle, (props) => ReferenceLines({...props, referenceLinesPanel}), XAxis, ...YAxes(tile.value.style.yAxis), DataLabels, Colors, Legend, OtherOptions]
        .map((panel) =>
            panel({
                tile,
                form,
                size,
                parentTile,
                colorsTileConfig,
                tileAction,
                isContainerTile,
            })
        )
        .filter((v) => v);
